import React from 'react';

import Layout from '../layouts/Layout';
import ErrorPage from './ErrorPage';
import LoadingPage from './LoadingPage';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: Record<string, any>;
  pastDelay: boolean;
};
export default class LoadableLoadingPage extends React.PureComponent<Props> {
  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.error) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      return <ErrorPage error={this.props.error} />;
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.pastDelay) {
      return <LoadingPage delay={0} />;
    }

    return <Layout />;
  }
}
